import React from 'react';
import I18n from 'lib/i18n/i18n';
import ImageUploaderWrapper from '../imageUploader/ImageUploaderWrapper';
import { dataAutomationAttr } from '../../helpers/ApplicationHelper';
import BlackBox from './blackBox';
import UserActions from '../../lib/userActions';

class UploadImageComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { item, clickOnBox, version, onUploadSuccess, uploadStart, setPhoto, logAction } = this.props;

        const onSuccess = (res) => {
            onUploadSuccess(res);
            UserActions.lightListingPage(`${item.desc} add photo clicked`, item.id, this.props.version);
        };

        return (
            <>
                <ImageUploaderWrapper key="image-uploader-container"
                                      className="listing-upload-photo"
                                      item={ item }
                                      multiple={ false }
                                      optimizedWidth={ 300 } /* Reducing loading time from, thanks to Cloudinary transformations. 300px = 2 * the block width */
                                      optionalText={ I18n.getString('listingPage::listingUploadPhoto::optionalText') }
                                      optionalSubText={ I18n.getString('listingPage::listingUploadPhoto::optionalSubText') }
                                      data-automation={ dataAutomationAttr('image-uploader') }
                                      onSuccess={ (res) => onSuccess(res) }
                                      onFailure={ () => true }
                                      onBeforeUpload={ uploadStart }
                                      showImages={ false }
                                      onRemoveAll={ setPhoto }/>

                <BlackBox
                    data-automation={ dataAutomationAttr('studio-photos-black-box') }
                    onClickMe={ () => {
                        logAction('"Studio photos" clicked');
                        clickOnBox('photos', item, version);
                    } } caption={ I18n.getString('listingPageLight::itemDetails::studioPhotos') }/>
                <span className="font-roboto-300">
                    <BlackBox
                        data-automation={ dataAutomationAttr('lab-report-black-box') }
                        onClickMe={ () => {
                            logAction('"Lab report" clicked');
                            clickOnBox('grading', item, version);
                        } } caption={ I18n.getString('listingPageLight::itemDetails::labReport') }/>
                </span>
            </>
        );
    }
}

export default UploadImageComponent;
